/**
 * 药事服务相关路由
 */
export default [
  /**
   * 处方列表
   */
  {
    path: '/recipe/list',
    meta: {
      title: '我的处方'
    },
    component: () => import('../pages/recipe/list'),
    children: [
      {
        path: ':id',
        meta: {
          title: '我的处方'
        },
        component: () => import('../../src/pages/recipe/list-state.vue')
      }
    ]
  },
  /**
   * 处方详情
   */
  {
    path: '/recipe/detail',
    meta: {
      title: '我的处方'
    },
    component: () => import('../pages/recipe/detail')
  },
  /**
   * 配送确认
   */
  {
    path: '/recipe/ship-confirm',
    meta: {
      title: '确认订单'
    },
    component: () => import('../pages/recipe/ship-confirm')
  },
  /**
   * 取药须知
   */
  {
    path: '/recipe/take-notice',
    meta: {
      title: '取药须知'
    },
    component: () => import('../pages/recipe/take-notice')
  },
  /**
   * 确认订单
   */
  {
    path: '/recipe/confirm',
    meta: {
      title: '确认订单'
    },
    component: () => import('../pages/recipe/confirm')
  },
  /**
   * 确认订单
   */
  {
    path: '/recipe/confirmDrug',
    meta: {
      title: '确认订单'
    },
    component: () => import('../pages/recipe/confirmDrug')
  },
  /**
   * 药品查询
   */
  {
    path: '/recipe/ypcx',
    meta: {
      title: '药品查询'
    },
    component: () => import('../pages/recipe/ypcx')
  }
]



// WEBPACK FOOTER //
// ./src/router/recipe.js